import { useState } from 'react'
import { Text } from '@chakra-ui/react'
import useAppointments from 'hooks/useAppointments/useAppointments'
import { formatTime } from 'utils/time.utils'
import { BookingEventSource } from 'utils/amplitude.types'
import './styles.scss'
import CancellationPolicyModal from 'components/Scheduling/CancellationPolicyModal'
import { Appointment } from 'types/appointments'
import { RoutePaths } from 'containers/Core/Routes'
import { isWithin24Hours } from 'utils/appointments.utils'

interface AppointmentBannerProps {
  program: string | undefined
  medicalApptTypeId: string | undefined
  nutritionalApptTypeId: string | undefined
  isFollowUpRdTypeId: boolean
}

const AppointmentBanner: React.FC<AppointmentBannerProps> = ({
  program,
  medicalApptTypeId,
  nutritionalApptTypeId,
  isFollowUpRdTypeId,
}: AppointmentBannerProps) => {
  const { getUpcomingAppointments } = useAppointments()
  const [
    isCancellationPolicyModalOpen,
    setIsCancellationPolicyModalOpen,
  ] = useState(false)

  const twoMostRecent = getUpcomingAppointments(2)

  const getPrimaryCopy = () => {
    if (program === 'nutrition-only') {
      if (isFollowUpRdTypeId) {
        return ''
      } else {
        return 'your first visit is already scheduled!'
      }
    }

    if (!medicalApptTypeId && nutritionalApptTypeId) {
      return 'your medical visit is already scheduled!'
    }

    if (!nutritionalApptTypeId && medicalApptTypeId) {
      return 'your nutrition visit is already scheduled!'
    }

    return 'both your medical and nutrition visits are already scheduled!'
  }

  const handleViewCancellationPolicy = async () => {
    setIsCancellationPolicyModalOpen(true)
  }

  const handleModifyAppointment = (sourceId: string) => {
    window.location.href = `${RoutePaths.SCHEDULING}?appointment=${sourceId}&source=${BookingEventSource.MANAGE}`
  }

  if (twoMostRecent.length === 0) {
    return null
  }

  return (
    <div className="appointment-screen-msg-container">
      <Text
        fontFamily="Inter"
        fontSize={['sm', 'md', 'lg']}
        fontWeight={700}
        color={'#000000'}
        marginBottom={0}
      >
        Great job, {getPrimaryCopy()}
      </Text>
      {twoMostRecent.map((appointment, index) => {
        return (
          <>
            <div key={index} className="appointment-detail-row">
              <span
                className="appointment-manage-model-open-row"
                onClick={
                  isWithin24Hours(appointment.time)
                    ? handleViewCancellationPolicy
                    : () => handleModifyAppointment(appointment.sourceId)
                }
              >
                <AppointmentDetails appointment={appointment} />
              </span>
              <span
                className="appointment-manage-modal-open-text"
                onClick={
                  isWithin24Hours(appointment.time)
                    ? handleViewCancellationPolicy
                    : () => handleModifyAppointment(appointment.sourceId)
                }
              >
                Modify
              </span>
            </div>
            <CancellationPolicyModal
              open={isCancellationPolicyModalOpen}
              handleClose={() => setIsCancellationPolicyModalOpen(false)}
            />
          </>
        )
      })}
    </div>
  )
}

interface AppointmentDetailsProps {
  appointment: Appointment
}

const AppointmentDetails: React.FC<AppointmentDetailsProps> = ({
  appointment,
}: AppointmentDetailsProps) => {
  return (
    <span>
      {appointment.type.category.includes('MD')
        ? 'Medical Visit '
        : 'Nutrition Visit '}
      &bull; {appointment.provider.firstName} {appointment.provider.lastName}{' '}
      &bull; {new Date(appointment.time).toLocaleDateString()}{' '}
      {formatTime(new Date(appointment.time))}
    </span>
  )
}

export default AppointmentBanner
